<script>
    import Card from "./card.svelte";
    export let urlDetails=""  ;
</script>
<style>
       .btn{
       color: #2e817d;
       border: 1px solid #2e817d;
       margin-top: 20%;
   }
</style>
<Card>   
    <div slot="body">
    <div style="float: left;">         
                <slot  name ="heading"/>     
                <slot name ="body"/>      
          
    </div>
    <div style="float: right;">
        <a class="btn" href={urlDetails}>Show</a>
    </div>
    </div>
   
</Card>